module.exports = __webpack_public_path__ + "static/media/icon.beeb7367.jpg";